import { ErrorHandler, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  /**
   * @description constructor
   * @params logger
   */
  constructor(private logger: NGXLogger) {
    this.logger = logger;
   }
  /**
   * @description handler error
   * @params error
   */
  handleError(error: any): void {
    this.logger.error(error);
  }
}
